module.exports = __webpack_public_path__ + "static/media/site.44fe19b8.webmanifest";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boostabostad-favicon/site.webmanifest
// module id = 391
// module chunks = 0